<div [id]="adId()" [style.width.px]="width()" [style.height.px]="height()" ></div>
